/**
 * Created by yniran on 12/14/14.
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        template = require("connection-templates/chatTab/chatContactProfileView.tmpl"),
        CP_CONST = require("connection-const"),
        Loader = require("ui/loader/Loader"),
        ChatContactModel = require("connection-models/chatTab/ChatContactModel"),
        ChatContactProfileView = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        var logger = LEConnection.logger;

        ChatContactProfileView = Marionette.ItemView.extend({
            template: template,
            model: ChatContactModel,
            ui: {
                "availability_indicator": ".chat-contact-profile-availability",
                "contactNotificationCounter": ".messaging-notifications-number",
                "container": ".chat-contact-profile-container",
                "displayName": ".chat-contact-profile-displayName"
            },
            modelEvents: {
                "change:availability": "_onAvailabilityChange",
                "change:backupAvailability": "_onBackupAvailabilityChange",
                "change:notificationCounter": "_manageChatNotifications"
            },
            triggers: {
                "click": "chat:contact:clicked"
            },

            constructor: function (options) {
                this._contactType = options.contactType;
                this._hideOnAllOffline = options.hideOnAllOffline; //need this here to determine if should 'hide' class should be used when creating the container element

                Marionette.ItemView.prototype.constructor.apply(this, arguments);
            },

            customTemplateHelpers: function () {

                var uiFilterInfo = this._getFilteringInfoForUi();

                return _.extend({}, uiFilterInfo);
            },

            className: function () {
                return "chat-contact-profile-item " + (this._hideOnAllOffline ? "hide" : "");   //for users the default is hidden until they are online
            },

            initialize: function () {
                this.model.init();
                var availability = this.model.getAvailability();
            },

            attributes: function () {
                return {
                    "data-contactType": this._contactType
                };
            },

            onRender: function () {
                this._onAvailabilityChange(this.model);
                this._manageChatNotifications(this.model);
                if (this._contactType === CP_CONST.CONTACT_TYPE.USER && (!this.model.isUser() || this.model.isHidden())) {
                    this.$el.addClass("hide");
                }
                if (this._contactType === CP_CONST.CONTACT_TYPE.GROUP && (!this.model.isGroup() || this.model.isHidden())) {
                    this.$el.addClass("hide");
                }
            },

            _getFilteringInfoForUi: function () {

                var uiInfo = {};
                var info = this.model.getFilterInfo();

                if (info && info.filtered) {
                    var name = this.model.getDisplayName();
                    uiInfo.filteredDisplayName = name.replace(new RegExp(info.filteredWith, "i"), function (val) {
                        return "<span class=\"filter-highlight\">" + val + "</span>";
                    });
                }

                return uiInfo;
            },

            _onBackupAvailabilityChange: function (model) {
                var availability = model.getAvailability();
                if (this._contactType === CP_CONST.CONTACT_TYPE.GROUP && !availability) {
                    this._onAvailabilityChange(model);
                }
            },

            _onAvailabilityChange: function (model) {
                var value = model.getAvailability();
                if (this._contactType === CP_CONST.CONTACT_TYPE.GROUP) {
                    if (!value) {
                        value = model.getBackupAvailability();
                    }
                }
                logger.debug("handling contact availability change. new value: " + value, "ChatContactProfileView._onAvailabilityChange", model);

                var indicatorClassName = "chat-contact-profile-availability ";
                var isClickable = false;
                if (value) {
                    indicatorClassName += "profile-availability-online";
                    isClickable = true;
                } else {
                    indicatorClassName += "profile-availability-offline";
                }

                if (this.model.isMessagingContact()) {
                    this.ui.availability_indicator.addClass("hide");//remove online indicator
                } else {
                    this.ui.availability_indicator.attr("class", indicatorClassName);
                }
                if (this.model.isUser()) {
                    this._setClickableState(true);
                    this._updateIsVisible();
                } else {
                    this._setClickableState(isClickable);
                }
                this.trigger("availability:change");
            },

            _manageChatNotifications: function (model) {
                var counter = model.getNotificationCounter();
                if (counter > 0) {
                    this.ui.contactNotificationCounter.text(counter);
                }
                this._toggleChatCounter(counter > 0);
            },

            _toggleChatCounter: function (show) {
                this.ui.contactNotificationCounter.toggleClass("hide", !show);
            },

            _updateIsVisible: function () {
                if (this._hideOnAllOffline) {
                    var avail = this.model.getAvailability();
                    this.$el.toggleClass("hide", !avail);
                }
            },

            _setClickableState: function (clickable) {
                this.$el.toggleClass("clickable", clickable);
                if (clickable) {
                    this.ui.container.removeAttr("title");
                }
                else {
                    this.ui.container.attr("title", LE.translator.translate("LEConnection.chat.livePersonChatWidgetContactUnavailable"));
                }
            }
        });
    });

    return ChatContactProfileView;
});
